import { ORDER_TABLE_HEADERS } from 'utils/constants/Order';
import { SHIPMENT_TABLE_HEADERS } from 'utils/constants/Shipment';

export const generateDefaultShipmentColumns = () => {
  const defaultShipmentColumns = SHIPMENT_TABLE_HEADERS.map((header) => {
    const { width, options, ...headers } = header;
    const enabled = ![
      'est-act-departure',
      'planned-departure',
      'current-stop',
      'connection-status',
      'shared-with',
      'visibility-provided',
      'poo-port-name',
      'poo-departure-time',
      'poo-planned-departure',
      'pod-port-name',
      'pod-est-act-arrival',
      'pod-planned-arrival',
    ].includes(header.id);
    return { ...headers, enabled };
  });
  return { activeColumns: defaultShipmentColumns };
};

export const generateDefaultOrderColumns = () => {
  const defaultOrderColumns = ORDER_TABLE_HEADERS.map((header) => {
    const { width, options, ...headers } = header;
    return { ...headers, enabled: true };
  });
  return { activeColumns: defaultOrderColumns };
};
